import { useAuthStore } from "@/stores/auth";
import { useMaintenance } from "@/stores/maintenance";
import { useMenusStore } from "@/stores/sidebar";
import { createRouter, createWebHistory } from "vue-router";

const staticRoutes = [
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('@/pages/Maintenance.vue'),
    },
    {
        path: '/:pathMatch(.*)*', // Capture toutes les autres URL non définies
        name: 'Erreur',
        component: () => import('@/pages/Erreur.vue'), // Page d'erreur 404
    }
];

async function createDynamicRouter() {
    const menuStore = useMenusStore();
    if (menuStore.menuList.length === 0) {
        await menuStore.fetchRoutes();
    }
    const dynamicRoutes = menuStore.generateRoutes();

    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: [...staticRoutes, ...dynamicRoutes]
    });

    router.beforeEach(async (to, from, next) => {
        const maintenance = useMaintenance();
        const auth = useAuthStore();
        const isAuthenticated = auth.isAuthenticated;

        await maintenance.checkMaintenance();

        // Si le système est en maintenance, redirigez vers la page de maintenance
        if (maintenance.isMaintenance && to.path !== '/maintenance') {
            next({path: '/maintenance', 'name': 'Maintenance', query: {redirect: to.fullPath}});
        } else {
            // Vérifiez si la route nécessite une authentification
            if (to.meta.requiresAuth && !isAuthenticated) {
                next({ path: '/login', name: 'Login', query: { redirect: to.fullPath } });
            } else {
                // Si le user est connecté et essaie d'accéder à la page login, on le rédirige vers le dashboard
                if (isAuthenticated && to.path === '/login') {
                    next(from.fullPath || '/');
                } else {
                    // Si le user n'est pas connecté, on le redirige vers le login page
                    next();
                }
            }
        }
    });

    router.afterEach(async (to) => {
        if (to.meta.requiresAuth) {
            sessionStorage.setItem('lastVisitedUrl', to.fullPath || '/');
        }
    });
    return router;
}
export default createDynamicRouter;